import React, { useState } from 'react';
import { View, Text, StyleSheet } from 'react-native';

import {
  downloadReport,
  DownloadButton
} from 'app/src/elements/ReportDownload';

import { cardStyles as styles } from './index';

const InventoryReport = ({ data }) => {
  const [sellerId, setSellerId] = useState(null);
  const [soldStatus, setSoldStatus] = useState();

  const handleDownload = downloadProps => {
    downloadReport({
      ...downloadProps,
      path: 'inventory-report',
      params: { 'seller-id': sellerId, status: soldStatus }
    })
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Inventory Report</Text>
      <Text style={styles.label}>Seller:</Text>
      <select style={styles.select} onChange={(e) => setSellerId(e.target.value)}>
        <option key="seller-nil" value="">Select Seller</option>
        {data.sellers?.map(seller => (
          <option key={seller.id} value={seller.id}>
            {seller.fullDisplayName}
          </option>
        ))}
      </select>
      <Text style={styles.label}>Sold Status:</Text>
      <select style={styles.select} onChange={(e) => setSoldStatus(e.target.value)}>
        <option key="status-all">All</option>
        <option key="status-sold">Sold</option>
        <option key="status-notSold">Not Sold</option>
      </select>
      <DownloadButton handleDownload={handleDownload} />
    </View>
  );
};

export default InventoryReport;
